module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/rewards/inspiration-reward-50.836939d0.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/rewards/inspiration-reward-50.png
// module id = 3789
// module chunks = 11